var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmileFace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6668 23.3335C26.6668 23.3335 24.1668 26.6668 20.0002 26.6668C15.8335 26.6668 13.3335 23.3335 13.3335 23.3335M25.0002 15.0002H25.0168M15.0002 15.0002H15.0168M36.6668 20.0002C36.6668 29.2049 29.2049 36.6668 20.0002 36.6668C10.7954 36.6668 3.3335 29.2049 3.3335 20.0002C3.3335 10.7954 10.7954 3.3335 20.0002 3.3335C29.2049 3.3335 36.6668 10.7954 36.6668 20.0002ZM25.8335 15.0002C25.8335 15.4604 25.4604 15.8335 25.0002 15.8335C24.5399 15.8335 24.1668 15.4604 24.1668 15.0002C24.1668 14.5399 24.5399 14.1668 25.0002 14.1668C25.4604 14.1668 25.8335 14.5399 25.8335 15.0002ZM15.8335 15.0002C15.8335 15.4604 15.4604 15.8335 15.0002 15.8335C14.5399 15.8335 14.1668 15.4604 14.1668 15.0002C14.1668 14.5399 14.5399 14.1668 15.0002 14.1668C15.4604 14.1668 15.8335 14.5399 15.8335 15.0002Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileFace);
export default __webpack_public_path__ + "static/media/smileFace.f01651b32def973b97b799083fda2b7a.svg";
export { ForwardRef as ReactComponent };